export default __webpack_public_path__ + "static/media/gallery_05.6c5827c4.jpg";